class RapidSlider extends HTMLElement {
    constructor() {
        super();

        this.maxOffset = 100; //By default 100 pixels offset.
        this.prevArrow = this.querySelector(".prev-arrow");
        this.nextArrow = this.querySelector(".next-arrow");
        this.rapidSliderParent = this.querySelector(".rapid-slider");
        this.rapidSliderItems = this.querySelectorAll(".rapid-slider-item");
    }

    //Check each item width. and based on the item width we gonna offset the parent by that.
    //Make sure to store

    connectedCallback() {
        let sizes = [];
        this.rapidSliderItems.forEach((item) => (sizes = [...sizes, item.clientWidth]));
        this.maxOffset = Math.max(...sizes);

        //Check if all items are visibile in the screen.
        this.windowSizeChange();
        this.moveNext();
        this.movePrevious();
        window.dispatchEvent(new Event("resize"));
    }

    windowSizeChange() {
        try {
            window.addEventListener("resize", () => {
                const innerItemsSize =
                    Object.values(this.rapidSliderItems)
                        .map((item) => item.clientWidth)
                        .reduce((a, b) => a + b) - 10;

                if (innerItemsSize > this.rapidSliderParent.clientWidth) {
                    this.prevArrow.classList.add("lg:block");
                    this.nextArrow.classList.add("lg:block");
                    return;
                }
                this.prevArrow.classList.remove("lg:block");
                this.nextArrow.classList.remove("lg:block");
            });
        } catch (error) {
            console.log(error);
        }
    }

    moveNext() {
        this.nextArrow.addEventListener("click", () => {
            this.rapidSliderParent.scrollLeft = this.rapidSliderParent.scrollLeft + this.maxOffset;
        });
    }

    movePrevious() {
        this.prevArrow.addEventListener("click", () => {
            this.rapidSliderParent.scrollLeft = this.rapidSliderParent.scrollLeft - this.maxOffset;
        });
    }
}

customElements.define("rapid-slider", RapidSlider);
